export default function HowItWorks() {
  const steps = [
    {
      step: '01',
      title: 'Выбери товар',
      desc: 'Найди нужное на Taobao, 1688 или Weidian',
      icon: 'ri-search-line',
      imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20person%20browsing%20online%20shopping%20on%20laptop%2C%20warm%20beige%20background%2C%20clean%20editorial%20photography%2C%20soft%20natural%20light%2C%20cozy%20modern%20workspace%20aesthetic&width=600&height=800&seq=how-it-works-01&orientation=portrait',
    },
    {
      step: '02',
      title: 'Добавь в spreadsheet',
      desc: 'Внеси данные в удобную таблицу одним кликом',
      icon: 'ri-file-excel-2-line',
      imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20spreadsheet%20on%20laptop%20screen%2C%20warm%20neutral%20desk%20setup%2C%20soft%20natural%20lighting%2C%20modern%20workspace%20photography%2C%20organized%20professional%20aesthetic&width=600&height=800&seq=how-it-works-02&orientation=portrait',
    },
    {
      step: '03',
      title: 'Получи доставку',
      desc: 'Отслеживай заказ и получай посылку без лишних хлопот',
      icon: 'ri-truck-line',
      imageUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20package%20delivery%20concept%20with%20neutral%20beige%20background%2C%20clean%20editorial%20photography%2C%20soft%20natural%20light%2C%20elegant%20shipping%20aesthetic%2C%20warm%20professional%20tone&width=600&height=800&seq=how-it-works-03&orientation=portrait',
    },
  ];

  return (
    <section id="how-it-works" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Как это работает
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Три простых шага от выбора до получения
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((s) => (
            <div
              key={s.step}
              className="group relative rounded-2xl overflow-hidden cursor-default"
              style={{ aspectRatio: '3/4' }}
            >
              <img
                src={s.imageUrl}
                alt={s.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent"></div>
              <div className="absolute top-6 left-6">
                <span className="text-5xl font-heading font-extrabold text-white/30">
                  {s.step}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 rounded-full bg-white/15 backdrop-blur-sm flex items-center justify-center">
                    <i className={`${s.icon} text-white text-lg`}></i>
                  </div>
                </div>
                <h3 className="text-white font-heading text-xl font-bold mb-1">{s.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}